import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {GetServerSideProps} from "next";
import HeaderImageWithHeading from "../components/common/HeaderImageWithHeading";
import Image from "next/image";
import ContactUsPanel from "../components/ContactUsPanel/ContactUsPanel";
import {RegionInterface} from "../components/Regions/Regions";
import {getSafeLocale} from "../helpers/LocalizeObject";

export default function Page() {
	const {t} = useTranslation();

	const regions = t("pages.costaBrava.regions", {
		returnObjects: true
	}) as RegionInterface[];
	return (
		<>
			<HeaderImageWithHeading
				imageSrc={
					"/images/Costa_Brava.JPG"
				}
				title={t("pages.costaBrava.heading")!}
				subtitle={t("pages.costaBrava.subHeading")!}
			/>
			<div className="container mx-auto px-6 xl:px-0 my-20 flex flex-col gap-y-40 ">
				{regions.map((p, idx) => (
					<div
						className="flex flex-col xl:items-center xl:odd:flex-row md:even:flex-row-reverse gap-10 w-full"
						key={"leistung-" + idx}
					>
						<div className="flex-1 relative min-h-[300px] lg:min-h-[500px] shrink-0">
							<Image alt={p.title} src={p.img} fill className="cover" sizes="100vw" quality={90}/>
						</div>
						<div className="flex-1 items-start ">
							<div className="xl:px-24 flex flex-col gap-10">
								<h3 className="">{p.title}</h3>
								<p>{p.description}</p>
								<br/>
							</div>
						</div>
					</div>
				))}
			</div>
			<ContactUsPanel/>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const sst = await serverSideTranslations(getSafeLocale(context.locale) as string, [
		"common"
	]);
	return {
		props: {
			...sst
		}
	};
};
